// Splicing code into three's built-in shaders at their `#include` anchors
// (#76). A plain `String.replace` on a missing anchor silently does nothing,
// so a three upgrade that renames one would quietly drop a style's look;
// `splice` throws instead, and `styles.test.ts` compiles every style's
// materials against three's own shader source to catch it.

/** Where the code goes relative to the anchor. */
export type SpliceAt = "before" | "after" | "replace";

/** Puts `code` before, after or in place of the first `anchor` in `source`; throws if the anchor isn't there. */
export function splice(source: string, anchor: string, code: string, at: SpliceAt = "after"): string {
  const i = source.indexOf(anchor);
  if (i < 0) throw new Error(`shader anchor not found: ${anchor}`);
  const text = at === "replace" ? code : at === "before" ? `${code}\n${anchor}` : `${anchor}\n${code}`;
  return source.slice(0, i) + text + source.slice(i + anchor.length);
}
